<div class="welcome-container">
  <div class="welcome-content-container">
    <h1>Welcome!</h1>
    <p>
      <strong
        >Thank you for visiting TDOT's virtual public meeting for the proposed
        I-24 Southeast Choice Lanes project.</strong
      >
    </p>
    <p style="margin-bottom: 1.5rem">
      The purpose of this virtual public meeting is to:
    </p>
    <ul class="list-container">
      <li class="list-item">
        <img
          src="assets/icons/share-icon.svg"
          alt=""
          class="list-icon"
          aria-hidden="true"
        />
        <span class="list-text">
          <strong>Share</strong> project updates since our last public
          information meetings in August 2024.
        </span>
      </li>
      <li class="list-item">
        <img
          src="assets/icons/present-icon.svg"
          alt=""
          class="list-icon"
          aria-hidden="true"
        />
        <span class="list-text">
          <strong>Present</strong> updated environmental and traffic studies and
          design refinements.
        </span>
      </li>
      <li class="list-item">
        <img
          src="assets/icons/collect-icon.svg"
          alt=""
          class="list-icon collect-icon"
          aria-hidden="true"
        />
        <span class="list-text">
          <strong>Collect</strong> public comments and answer your questions
          about the proposed Project.
        </span>
      </li>
    </ul>
    <p>Please click the button below to enter the virtual public meeting.</p>
    <div class="get-started-button-container">
      <button
        class="get-started-button"
        (click)="goToProjectOverview()"
        aria-label="Get Started with the I-24 Southeast Choice Lanes Virtual Public Meeting"
        routerLink="/about-frpr"
      >
        Get Started <mat-icon>arrow_right</mat-icon>
      </button>
    </div>
  </div>
  <div class="welcome-banner-container">
    <img
      [src]="environment.cloudFrontUrl + '/content/welcome/Welcome_1.jpg '"
      alt=""
      role="presentation"
      class="welcome-banner"
    />
  </div>
</div>
